import request from "./axios";

function create(deal_id) {
  return request({
    method: "post",
    url: `/ai_sales_reports?deal_id=${deal_id}`
  });
}

const AiSalesReportService = {
  create
};

export default AiSalesReportService;
